import Button from '@atoms/Button/Button';
import Icon from '@atoms/Icon/Icon';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import { useState } from 'react';

import styles from './ExploreCard.module.scss';

interface Props {
  href: string;
  moreToExploreTitle: string;
  moreToExploreSubtitle: string;
  moreToExploreCta: string;
  moreToExploreLayOver: string;
}

export default function ExploreCard({
  href,
  moreToExploreTitle,
  moreToExploreSubtitle,
  moreToExploreCta,
  moreToExploreLayOver,
}: Props) {
  const router = useRouter();

  const [isOverlayVisible, setIsOverlayVisible] = useState(false);

  const handleClick = () => {
    setIsOverlayVisible(true);
    setTimeout(() => {
      router.push(href);
    }, 2000);
  };

  return (
    <>
      {isOverlayVisible && (
        <div className={styles.overlay}>
          <div className={styles.overlayContent}>
            <Icon icon="SPARKS" className={styles.overlaySparks} />
            <p>{moreToExploreLayOver}</p>
          </div>
        </div>
      )}
      <article className={styles.card}>
        <div className={styles.content}>
          <Icon icon="SPARKS" className={styles.sparks} />
          <h1 className={styles.title}>{moreToExploreTitle}</h1>
          <p className={styles.subtitle}>{moreToExploreSubtitle}</p>
          <Button
            type="button"
            label={moreToExploreCta}
            icon="NAV_ARROW_RIGHT"
            className={clsx(styles.readMoreButton, 'u-umbrella-link')}
            onClick={handleClick}
          />
        </div>
      </article>
    </>
  );
}
